import { Asset } from '@vendure/admin-ui/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

export function getImageUrl(image: Asset, preset: string) {
  return `${image.source}?preset=${preset}${
    image.focalPoint
      ? `&fpx=${image.focalPoint.x}&fpy=${image.focalPoint.y}`
      : ''
  }`;
}

export class CustomValidators {
  static EndAfterStartValidator(
    startName: string,
    endName: string,
  ): ValidatorFn {
    return (controls: AbstractControl) => {
      const startControl = controls.get(startName);
      const endControl = controls.get(endName);

      if (!startControl || !startControl.value || startControl?.errors)
        return null;
      if (!endControl || !endControl.value || endControl?.errors) return null;

      const start = new Date(startControl.value);
      const end = new Date(endControl.value);

      if (start > end) {
        endControl?.setErrors({
          afterStart: true,
        });
        return { afterStart: true };
      }
      return null;
    };
  }
}
